$(function() {
    DaNavigationFront.init();
})

var DaNavigationFront = {
    init: function() {
        $('.subnav-toggle').click(function() {
            $(this).toggleClass('fa-angle-down').toggleClass('fa-angle-up');
            $(this).siblings('ul').toggleClass('hidden');
        });
        // open parent who have child selected
        $('.danavigation-left').find('a.selected').each(function() {
            //open subnav if exists
            var closestToggle = $(this).siblings('.subnav-toggle');
            if (closestToggle.length == 0) closestToggle = $(this).parent().parent().siblings('.subnav-toggle');
            while (closestToggle.length > 0) {
                closestToggle.removeClass('fa-angle-down').addClass('fa-angle-up');
                closestToggle.siblings('ul').removeClass('hidden');
                closestToggle = closestToggle.parent().parent().siblings('.subnav-toggle');
            }
        });
    }
};

/*SIDEBAR RESPONSIVE*/
$('.background_sidebar').hide();

$('.button_sidebar').on("click", function () {
    $('.button_selector').toggleClass("button_selector_move");
    $('.boutton_illustration_sidebar_plus').fadeToggle("boutton_sidebar_plus_zindex");
    $('.block_sidebar').toggleClass("block_slide_sidebar");
    $('.background_sidebar').fadeToggle(300);
});